import Daily from "./Daily";
import Sales from "./Sales";
import Totals from "./Totals";
import Counts from "./Counts";
import WashCount from "./WashCount";
import SiteStatus from "./SiteStatus";
import AppActivity from "./AppActivity";
import IncomeByHour from "./IncomeByHour";
import AppBirthdayWashes from "./AppBirthdayWashes";
import AppTopWashClubUsers from "./AppTopWashClubUsers";
import ExpressPassActivity from "./ExpressPassActivity";
import TopExpressPassUsers from "./TopExpressPassUsers";
import AppLoyaltyPointAwards from "./AppLoyaltyPointAwards";

export const widgetIndex = [
    {
        label: 'Sales Summary',
        indexKey: 'daily',
        component: <Daily key='DailyWidget' />
    },
    {
        label: 'Site Status',
        indexKey: 'siteStatus',
        component: <SiteStatus key='SiteStatusWidget' />,
    },
    {
        label: 'Totals',
        indexKey: 'totals',
        minHeight: '50svh',
        component: <Totals key='TotalsWidget' />
    },
    {
        label: 'Counts',
        indexKey: 'counts',
        minHeight: '50svh',
        component: <Counts key='CountsWidget' />,
    },
    {
        label: 'Income By Hour',
        indexKey: 'incomeByHour',
        minHeight: '40svh',
        component: <IncomeByHour key='IncomeByHourWidget' />,
    },
    {
        label: 'Sales',
        indexKey: 'sales',
        minHeight: '40svh',
        component: <Sales key='SalesWidget' />,
    },
    {
        label: 'App Activity',
        indexKey: 'appActivity',
        component: <AppActivity key='AppActivity' />,
    },
    {
        label: 'ExpressPass Activity',
        indexKey: 'expressPassActivity',
        component: <ExpressPassActivity key='ExpressPassActivity' />,
    },
    {
        label: 'Loyalty Point Awards',
        indexKey: 'appLoyaltyPointAwards',
        component: <AppLoyaltyPointAwards key='AppActivity' />,
    },
    {
        label: 'Top Wash Club Users',
        indexKey: 'appTopWashClubUsers',
        component: <AppTopWashClubUsers key='AppTopWashClubUsers' />,
    },
    {
        label: 'Top ExpressPass Users',
        indexKey: 'topExpressPassUsers',
        component: <TopExpressPassUsers key='TopExpressPassUsers' />,
    },
    {
        label: 'Birthday Washes',
        indexKey: 'appBirthdayWashes',
        component: <AppBirthdayWashes key='AppBirthdayWashes' />,
    },
    {
        label: 'Total Washes',
        indexKey: 'washCount',
        component: <WashCount key='washCount' />,
    }
]

export const defaultWidgets = widgetIndex.map(e => e.indexKey);
